<template>
<DeliverSearchDetail ref="DeliverSearchDetail" :special-handler="specialHandler" :special-table-data="tableData">
    <template #X_Slot1>
        <el-table-column v-if="true" prop="X_PerPieceQty" column-key="X_PerPieceQty" align="right" :min-width="WidthControl('X_PerPieceQty&&SUnitName',tableData,7)" :label="$t('speOrder.X_PerPieceQty')">
          <template slot-scope="scope">
            <span v-if="!scope.row.edit">{{ scope.row.X_PerPieceQty}}&nbsp{{ scope.row.SUnitName }}</span>
            <div v-if="scope.row.edit" class="editcell">
              <el-input size="small" maxlength="23" class="editinput" @change="editX_PerPieceQty(scope.row,scope.row.X_PerPieceQty)" v-model="scope.row.X_PerPieceQty"></el-input>
              <span class="editUnitName">{{ scope.row.SUnitName }}</span>
            </div>
          </template>
        </el-table-column>
    </template>
</DeliverSearchDetail>
</template>
<script>
import DeliverSearchDetail from '@/view/DeliverSearchDetail.vue';
import {isValidNumeric} from '@/utils/utils'
export default{
    components:{
        DeliverSearchDetail
    },
    data(){
        return{
            specialHandler:'/SupplierComm/Handler/ZLOrderHandler.ashx',
            tableData:[],
        }
    },
    methods:{
        editX_PerPieceQty(row,X_PerPieceQty){
            let fieldValue = String(X_PerPieceQty);
            this.tableLoading = true;
            if(isValidNumeric(fieldValue,19,9)){
                row.errorRow = false;
                this.axiosInvoke(this.specialHandler,{
                    action:'formatvalue',
                    Type:'Quantity',
                    FOrgId:this.$refs.DeliverSearchDetail.FOrgId,
                    Value:fieldValue,
                    Unit:row.SUnitId
                },(res)=>{
                    this.tableLoading = false;
                    let data = res.data;
                    row.X_PerPieceQty = data.Value;
                    this.$refs.DeliverSearchDetail.AddchangeData(row,'X_PerPieceQty');
                })
            }else{
                this.tableLoading = false;
                row.errorRow = true;
                row.X_PerPieceQty = "";
                this.$store.commit("TIPPOP",{popType:'warning',popMessage:this.$t("DeliverDetail.numbertip")});
            }
        }
    }
}
</script>
<style scoped>
.editcell{
  display: flex;
  justify-content: flex-end;
}
.editcell /deep/ .el-input__inner{
  padding: 0 5px;
  min-width: 60px;
}
.editinput{
  padding:0 2%;
  margin: auto 0;
  max-width: 75%;
  min-width: calc( 60px + 4% );
}
.editUnitName{
  margin: auto 0;
}
</style>
